module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "houseSibReport"
  }, [_vm._v("\n    ====================》这是houseSibReport页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b0dcde88","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/houseSibReport.vue
// module id = 1185
// module chunks = 1